import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Print.css";
import dayjs from "dayjs";
import {
  FaArrowLeft,
  FaStore,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { GiMedicines } from "react-icons/gi";
import { RiPriceTag3Line } from "react-icons/ri";
import { BsCashStack } from "react-icons/bs";
import { MdOutlineDescription } from "react-icons/md";

const ObatDetail = () => {
  const param = useParams();
  const flag = param["*"];
  const [obatDetail, setObatDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedOutlets, setExpandedOutlets] = useState({});
  const [showStockCard, setShowStockCard] = useState(false);
  const [stockCardData, setStockCardData] = useState([]);
  const [loadingStockCard, setLoadingStockCard] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showHistory, setShowHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [showAllStock, setShowAllStock] = useState(false);
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const idOutlet = parseInt(localStorage.getItem("id_outlet"));
  const itemsPerPage = 10;
  const printRef = useRef();
  const [triggerPrint, setTriggerPrint] = useState(false);
  useEffect(() => {
    if (showAllStock && triggerPrint) {
      console.log("Triggering print...");
      console.log(document.getElementById("printArea")?.innerText);
      setTimeout(() => {
        window.print();
        setTriggerPrint(false);
      }, 800);
    }
  }, [showAllStock, triggerPrint]);
  useEffect(() => {
    const fetchObatDetail = async () => {
      try {
        let newParam = encodeURI(flag);
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/drug/detail/${newParam}`;

        const response = await fetch(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setObatDetail(data.data);
      } catch (error) {
        setError("Gagal mengambil detail obat");
      } finally {
        setLoading(false);
      }
    };

    fetchObatDetail();
  }, [flag]);

  const toggleOutlet = (index) => {
    setExpandedOutlets((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleShowStockCard = async () => {
    if (!obatDetail?.id) return;
    setShowStockCard(true);
    setLoadingStockCard(true);

    let url = `${process.env.REACT_APP_API_BASE_URL}/v1/drug/stock-card/${obatDetail.id}`;
    if (role === "manager" && idOutlet) {
      url += `?outlet_id=${idOutlet}`;
    }

    try {
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      setStockCardData(result.data || []); // ❗ ambil semua data
    } catch (err) {
      console.error("Gagal mengambil kartu stok", err);
    } finally {
      setLoadingStockCard(false);
    }
  };

  const fetchOutlets = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const result = await res.json();
      setOutlets(result.data || []);
    } catch (error) {
      console.error("Gagal mengambil data outlet", error);
    }
  };
  const handleShowHistory = async () => {
    if (!obatDetail?.id) return;

    setShowHistory(true);
    setHistoryData([]);
    setLoadingHistory(true);

    if (role === "owner") {
      await fetchOutlets();
      return; // tunggu user pilih outlet dulu
    }

    const idOutlet = localStorage.getItem("id_outlet");
    if (!idOutlet) return;

    fetchHistoryData(idOutlet);
  };

  const fetchHistoryData = async (idOutletTarget) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/drug/history/${obatDetail.id}/${idOutletTarget}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();

      if (Array.isArray(result.data)) {
        setHistoryData(result.data);
      } else {
        setHistoryData([]);
      }
    } catch (err) {
      console.error("Gagal mengambil history", err);
      setHistoryData([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  if (loading) return <p className="p-6">Memuat data...</p>;
  if (error) return <p className="p-6 text-red-500">{error}</p>;
  const totalPages = Math.ceil(historyData.length / itemsPerPage);

  const paginatedHistory = historyData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="flex transition-all duration-500">
      {/* Panel Kiri */}

      <div className="transition-all duration-500 p-6 w-full">
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <div className="text-sm text-gray-600 mb-6 flex items-center gap-2">
            <FaArrowLeft className="text-green-600" />
            <span className="text-green-600 font-medium">Obat</span> /
            <span>Detail</span> /
            <span className="font-semibold text-gray-800">
              {obatDetail.name} {obatDetail.dosis}
            </span>
          </div>

          <div className="flex flex-col md:flex-row gap-6">
            <div className="md:w-1/3 flex flex-col items-center">
              <div className="bg-gray-100 rounded-xl aspect-square w-full flex items-center justify-center">
                <GiMedicines className="text-6xl text-gray-400" />
              </div>
              <div className="flex flex-col gap-2 mt-6 w-full">
                <button
                  onClick={handleShowHistory}
                  className="px-4 py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600 w-full"
                >
                  History Purchasing
                </button>
                <button
                  onClick={handleShowStockCard}
                  className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 w-full"
                >
                  Kartu Stok
                </button>
              </div>
            </div>

            <div className="md:w-2/3">
              <h1 className="text-2xl font-bold text-gray-900 mb-1">
                {obatDetail.name} {obatDetail.dosis}
              </h1>
              <p className="text-sm text-gray-600 font-medium">
                {obatDetail.produsen}
              </p>
              <div className="flex flex-wrap items-center gap-6 mt-4">
                <div className="text-green-600 font-bold text-lg flex items-center">
                  <RiPriceTag3Line className="mr-2" />
                  Rp{" "}
                  {obatDetail.harga_jual.toLocaleString("id-ID", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
                <div className="text-red-600 font-bold text-lg flex items-center">
                  <BsCashStack className="mr-2" />
                  Rp{" "}
                  {obatDetail.harga_beli.toLocaleString("id-ID", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
              </div>

              <div className="mt-6">
                <h2 className="text-lg font-bold flex items-center text-gray-800 mb-2">
                  <FaStore className="text-green-500 mr-2" /> Lokasi & Stok
                </h2>
                <ul className="space-y-2">
                  {obatDetail.outlet.map((lokasi, index) => {
                    if (role === "manager" && lokasi.id !== idOutlet)
                      return null;
                    return (
                      <li key={index} className="border rounded-md">
                        <button
                          onClick={() => toggleOutlet(index)}
                          className="w-full flex justify-between px-4 py-2 font-medium text-gray-800"
                        >
                          <span>• {lokasi.name}</span>
                          <div className="flex items-center gap-2">
                            <span>Stock: {lokasi.stock.toLocaleString()}</span>
                            {expandedOutlets[index] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </div>
                        </button>
                        {expandedOutlets[index] &&
                          lokasi.exps_at?.length > 0 && (
                            <ul className="px-6 py-2 text-sm text-gray-700 space-y-1">
                              {lokasi.exps_at.map((exp, i) => (
                                <li key={i} className="flex justify-between">
                                  <span>
                                    {dayjs(exp.expired_at).format("YYYY-MM-DD")}
                                  </span>
                                  <span>Stock: {exp.stock}</span>
                                </li>
                              ))}
                            </ul>
                          )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 border-t pt-6">
            <h2 className="text-lg font-bold flex items-center text-gray-800 mb-2">
              <MdOutlineDescription className="text-blue-500 mr-2" />
              Deskripsi
            </h2>
            <p className="text-gray-700 text-justify leading-relaxed">
              <strong>
                {obatDetail.name} {obatDetail.dosis}
              </strong>{" "}
              {obatDetail.desc || "Deskripsi tidak tersedia."}
            </p>
          </div>
        </div>
      </div>
      {showStockCard && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white w-[700px] max-h-[90vh] overflow-auto rounded-xl shadow-lg p-6 relative">
            <button
              className="absolute top-2 right-2 text-red-600 text-lg"
              onClick={() => setShowStockCard(false)}
            >
              ✕
            </button>

            <h2 className="text-lg font-bold text-purple-600 mb-2">
              Kartu Stok: {obatDetail?.name} {obatDetail?.dosis}
            </h2>

            {loadingStockCard ? (
              <p>Memuat data kartu stok...</p>
            ) : (
              <table className="w-full border text-sm text-gray-700 mb-4">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1">No</th>
                    <th className="border px-2 py-1">Tanggal</th>
                    <th className="border px-2 py-1">Ref</th>
                    <th className="border px-2 py-1">Masuk</th>
                    <th className="border px-2 py-1">Keluar</th>
                    <th className="border px-2 py-1">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {(showAllStock
                    ? stockCardData
                    : stockCardData.slice(0, 10)
                  ).map((item, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-1 text-center">
                        {index + 1}
                      </td>
                      <td className="border px-2 py-1 text-center">
                        {dayjs(item.log_at).format("DD-MM-YYYY")}
                      </td>
                      <td className="border px-2 py-1 text-center">
                        {item.code}
                      </td>
                      <td className="border px-2 py-1 text-center">
                        {item.qty > 0 ? item.qty : ""}
                      </td>
                      <td className="border px-2 py-1 text-center">
                        {item.qty < 0 ? item.qty : ""}
                      </td>
                      <td className="border px-2 py-1">{item.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <div className="flex justify-between mt-2 gap-2">
              <button
                onClick={() => setShowAllStock(!showAllStock)}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                {showAllStock ? "Tampilkan 10 Teratas" : "Tampilkan Semua"}
              </button>
              <button
                onClick={() => {
                  setShowAllStock(true);
                  setTriggerPrint(true);
                }}
                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
              >
                Print
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        id="printArea"
        className="hidden print:block p-6 bg-white text-black"
      >
        <h2 className="text-lg font-bold mb-4">
          Kartu Stok: {obatDetail?.name} {obatDetail?.dosis}
        </h2>
        <table className="w-full text-left border text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-2 py-1">No</th>
              <th className="border px-2 py-1">Tanggal</th>
              <th className="border px-2 py-1">Ref</th>
              <th className="border px-2 py-1">Masuk</th>
              <th className="border px-2 py-1">Keluar</th>
              <th className="border px-2 py-1">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            {stockCardData.map((item, index) => (
              <tr key={index}>
                <td className="border px-2 py-1 text-center">{index + 1}</td>
                <td className="border px-2 py-1 text-center">
                  {dayjs(item.log_at).format("DD-MM-YYYY")}
                </td>
                <td className="border px-2 py-1 text-center">{item.code}</td>
                <td className="border px-2 py-1 text-center">
                  {item.qty > 0 ? item.qty : ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {item.qty < 0 ? item.qty : ""}
                </td>
                <td className="border px-2 py-1">{item.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Panel Kartu Stok */}
      {showHistory && (
        // <div className="w-3/5 h-full border-l bg-white shadow-xl p-6 overflow-y-auto fixed top-0 right-0 z-40 transition-all duration-500">
        <div
          className={`border-l bg-white shadow-xl p-6 transition-all duration-500 p-6 ${
            showHistory ? "w-3/5" : "w-full"
          }`}
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-bold text-indigo-600">
              History Purchasing
            </h2>
            <button
              onClick={() => setShowHistory(false)}
              className="text-gray-500 hover:text-red-500 text-lg"
            >
              ✕
            </button>
          </div>

          {role === "owner" && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Pilih Outlet
              </label>
              <select
                value={selectedOutlet || ""}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSelectedOutlet(selected);
                  fetchHistoryData(selected);
                }}
                className="border rounded px-3 py-2 w-full"
              >
                <option value="">-- Pilih Cabang --</option>
                {outlets.map((outlet) => (
                  <option key={outlet.id} value={outlet.id}>
                    {outlet.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {loadingHistory ? (
            <p>Memuat data...</p>
          ) : Array.isArray(historyData) && historyData.length > 0 ? (
            <div className="overflow-auto text-sm">
              <table className="w-full border text-gray-700 text-left">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-3 py-2">No</th>
                    <th className="border px-3 py-2">Supplier</th>
                    <th className="border px-3 py-2">Harga</th>
                    <th className="border px-3 py-2">Kode Referensi</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedHistory.map((item, index) => (
                    <tr key={index}>
                      <td className="border px-3 py-2 text-center">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="border px-3 py-2">{item.name}</td>
                      <td className="border px-3 py-2">
                        Rp {item.price?.toLocaleString() || "-"}
                      </td>
                      <td className="border px-3 py-2">
                        {item.ref?.code || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex justify-between items-center mt-4">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                Prev
              </button>

              <span className="text-sm">
                Halaman {currentPage} dari {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
            </div>
          ) : (
            <p className="text-gray-500">Data tidak tersedia.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ObatDetail;
